import type { BifrostWeb } from '@seekrtech/bifrost-web'
import type { Result } from '../types'

export interface PermissionServiceMethods {
  getHasNotificationPermission: () => Promise<Result<boolean>>
  requestNotificationPermission: () => Promise<Result<boolean>>
}

export function createPermissionService(
  bifrost: BifrostWeb,
): PermissionServiceMethods {
  return bifrost
    .createProxyBuilder<PermissionServiceMethods>('PermissionService')
    .withDefaultOptions({ timeout: 31_536_000_000 })
    .build()
}
